<template>
  <div>
    <div class="section">
      <div class="container">
        <!-- Page Header -->
        <div class="columns is-vcentered">
          <div class="column is-one-third">
            <breadcrumbs :history="[{ label: 'Products', name: 'catalog'}]" current="New Product Proposal" :hideBack="true" />
          </div>
          <div class="column is-one-third">
            <h1 class="has-text-centered is-size-4">Submit New Product Proposal</h1>
          </div>
        </div>
        <!-- Wizard -->
        <div>
          <div class="columns is-centered">
            <div class="column is-two-thirds-desktop is-half-widescreen">
              <div class="box">
                <transition name="fade" mode="out-in">
                  <component :is="step"
                    :feed="feed"
                    :feedDetails="feedDetails"
                    @feed:queued="trackFeed"
                    @feedDetails:queued="trackFeedDetails"
                    @navigate="navigate"
                  ></component>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Build from '../components/Submit/Build'
import Progress from '../components/Submit/Progress'

export default {
  components: {
    Build,
    Progress
  },
  computed: {
    ...mapGetters(['app', 'context'])
  },
  data () {
    return {
      step: null,
      feed: null,
      feedDetails: null
    }
  },
  methods: {
    navigate (step) {
      this.step = step
      window.scrollTo(0, 0)
    },
    trackFeed (feed) {
      this.feed = feed
    },
    trackFeedDetails (feedDetails) {
      this.feedDetails = feedDetails
    }
  },
  mounted () {
    if (this.$route.query.feed_id) {
      this.feed = {
        id: this.$route.query.feed_id
      }
    }
    const steps = ['Build', 'Progress']
    if ('step' in this.$route.query && steps.includes(this.$route.query.step)) {
      this.step = this.$route.query.step
    } else {
      this.step = 'Build'
    }
  }
}
</script>
